import React, { Dispatch, SetStateAction } from 'react'

import { Modal } from '@mui/material'
import Backdrop from '@mui/material/Backdrop'
import Spinner from 'components/Transactions/Spinner'

export interface SpinnerModalProps {
  spinnerModalOpen: boolean
  setSpinnerModalOpen: Dispatch<SetStateAction<boolean>>
  text?: string
}

const SpinnerModal = ({
  spinnerModalOpen,
  setSpinnerModalOpen,
  text = 'Connecting'
}: SpinnerModalProps) => {
  return (
    <Modal
      open={spinnerModalOpen}
      onClose={() => setSpinnerModalOpen(false)}
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500
      }}
      className="overflow-auto modal-bg"
    >
      <div className="flex absolute top-1/2 left-1/2 flex-col justify-center items-center px-4 translate-x-[-50%] translate-y-[-50%] size-full">
        <div className="flex flex-col gap-6 items-center">
          <Spinner isLarge={true} />
          <p className="text-2xl text-white">{text}</p>
        </div>
      </div>
    </Modal>
  )
}

export default SpinnerModal
